module.exports = __webpack_public_path__ + "static/img/company_history1996.2dbc3648.jpg";